import React, { useState , useEffect } from 'react'
import MUIDataTable from "mui-datatables";
import Container from '@mui/material/Container';


function ComerciosConsulta() {
  const [comercios,setComercios] = useState([]);
  const columns = ["id",{name: "fecha_alta"},"cuit", "razon_social", "email","web","contacto", "nombredefantasia","socioucip","estado","detalle_aprobacion","localidad","provincia","rubro"]

const options = {
    textLabels: {
      body: {
        noMatch: "Lo siento, no se encontraron registros",
        toolTip: "Ordenar",
        columnHeaderTooltip: column => `Ordenar por ${column.label}`
      },
      pagination: {
        next: "Siguiente Página",
        previous: "Anterior Página",
        rowsPerPage: "Filas por Página:",
        displayRows: "de"
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver Columnas",
        filterTable: "Filtrar Tabla"
      },
      filter: {
        all: "TODOS",
        title: "FILTROS",
        reset: "REINICIAR"
      },
      viewColumns: {
        title: "Mostrar Columnas",
        titleAria: "Mostrar/Ocultar Columnas"
      },
      selectedRows: {
        text: "fila(s) seleccionada(s)",
        delete: "Eliminar",
        deleteAria: "Eliminar filas seleccionadas"
      }
    },
};

const getComercios = () => {
    const baseURL = process.env.REACT_APP_SERVER_PATH+'comerciosTodos2';
    fetch(`${baseURL}`)
     .then(res => res.json())
    .then(
      (result) => {
      setComercios(result);
      },
      (error) => {
      }
    )
   }

useEffect(() => {
    getComercios(); 
},[])

  return (
    <>
       <Container component="main" maxWidth="xlg" style={{ marginTop: "30px", marginBottom: "35px"}}>
          <MUIDataTable
          title={"Lista de comercios"}
          data={comercios}
          columns={columns}
          options={options}
          />
       </Container>
      </>
  )
}

export default ComerciosConsulta